// icons — one deep import per icon so the bundle carries only what we ship.
// Browse the set at https://phosphoricons.com
//
// These come from `dist/ssr`, not the default `dist/csr`. The two ship the same
// glyphs and the same props; the only difference is that the csr build reads its
// defaults from a React context, which the Next.js apps cannot evaluate while
// collecting page data. The ssr build is a plain forwardRef, so it renders on
// both the server and the client. Nothing here uses `IconContext`, so there is
// no behaviour to lose by taking it.

import type { Icon } from '@phosphor-icons/react';

import { AppleLogoIcon } from '@phosphor-icons/react/dist/ssr/AppleLogo';
import { ArrowCircleDownIcon } from '@phosphor-icons/react/dist/ssr/ArrowCircleDown';
import { ArrowCircleUpIcon } from '@phosphor-icons/react/dist/ssr/ArrowCircleUp';
import { ArrowClockwiseIcon } from '@phosphor-icons/react/dist/ssr/ArrowClockwise';
import { ArrowLeftIcon } from '@phosphor-icons/react/dist/ssr/ArrowLeft';
import { ArrowRightIcon } from '@phosphor-icons/react/dist/ssr/ArrowRight';
import { ArrowSquareOutIcon } from '@phosphor-icons/react/dist/ssr/ArrowSquareOut';
import { ArrowsClockwiseIcon } from '@phosphor-icons/react/dist/ssr/ArrowsClockwise';
import { BedIcon } from '@phosphor-icons/react/dist/ssr/Bed';
import { BellIcon } from '@phosphor-icons/react/dist/ssr/Bell';
import { BookIcon } from '@phosphor-icons/react/dist/ssr/Book';
import { BookOpenIcon } from '@phosphor-icons/react/dist/ssr/BookOpen';
import { BookmarkIcon } from '@phosphor-icons/react/dist/ssr/Bookmark';
import { BuildingsIcon } from '@phosphor-icons/react/dist/ssr/Buildings';
import { BusIcon } from '@phosphor-icons/react/dist/ssr/Bus';
import { CalendarBlankIcon } from '@phosphor-icons/react/dist/ssr/CalendarBlank';
import { CalendarCheckIcon } from '@phosphor-icons/react/dist/ssr/CalendarCheck';
import { CalendarDotsIcon } from '@phosphor-icons/react/dist/ssr/CalendarDots';
import { CameraIcon } from '@phosphor-icons/react/dist/ssr/Camera';
import { CaretDoubleDownIcon } from '@phosphor-icons/react/dist/ssr/CaretDoubleDown';
import { CaretDoubleLeftIcon } from '@phosphor-icons/react/dist/ssr/CaretDoubleLeft';
import { CaretDoubleRightIcon } from '@phosphor-icons/react/dist/ssr/CaretDoubleRight';
import { CaretDoubleUpIcon } from '@phosphor-icons/react/dist/ssr/CaretDoubleUp';
import { CaretDownIcon } from '@phosphor-icons/react/dist/ssr/CaretDown';
import { CaretLeftIcon } from '@phosphor-icons/react/dist/ssr/CaretLeft';
import { CaretRightIcon } from '@phosphor-icons/react/dist/ssr/CaretRight';
import { CaretUpIcon } from '@phosphor-icons/react/dist/ssr/CaretUp';
import { ChatIcon } from '@phosphor-icons/react/dist/ssr/Chat';
import { ChatDotsIcon } from '@phosphor-icons/react/dist/ssr/ChatDots';
import { ChatsIcon } from '@phosphor-icons/react/dist/ssr/Chats';
import { CheckIcon } from '@phosphor-icons/react/dist/ssr/Check';
import { CheckCircleIcon } from '@phosphor-icons/react/dist/ssr/CheckCircle';
import { CheckSquareIcon } from '@phosphor-icons/react/dist/ssr/CheckSquare';
import { CircleIcon } from '@phosphor-icons/react/dist/ssr/Circle';
import { CityIcon } from '@phosphor-icons/react/dist/ssr/City';
import { ClipboardIcon } from '@phosphor-icons/react/dist/ssr/Clipboard';
import { ClipboardTextIcon } from '@phosphor-icons/react/dist/ssr/ClipboardText';
import { ClockIcon } from '@phosphor-icons/react/dist/ssr/Clock';
import { ClosedCaptioningIcon } from '@phosphor-icons/react/dist/ssr/ClosedCaptioning';
import { CloudArrowDownIcon } from '@phosphor-icons/react/dist/ssr/CloudArrowDown';
import { CloudArrowUpIcon } from '@phosphor-icons/react/dist/ssr/CloudArrowUp';
import { CoinsIcon } from '@phosphor-icons/react/dist/ssr/Coins';
import { ConfettiIcon } from '@phosphor-icons/react/dist/ssr/Confetti';
import { CopyIcon } from '@phosphor-icons/react/dist/ssr/Copy';
import { CouchIcon } from '@phosphor-icons/react/dist/ssr/Couch';
import { CurrencyGbpIcon } from '@phosphor-icons/react/dist/ssr/CurrencyGbp';
import { DiscIcon } from '@phosphor-icons/react/dist/ssr/Disc';
import { DotsThreeIcon } from '@phosphor-icons/react/dist/ssr/DotsThree';
import { DotsThreeVerticalIcon } from '@phosphor-icons/react/dist/ssr/DotsThreeVertical';
import { DownloadIcon } from '@phosphor-icons/react/dist/ssr/Download';
import { EnvelopeIcon } from '@phosphor-icons/react/dist/ssr/Envelope';
import { EnvelopeOpenIcon } from '@phosphor-icons/react/dist/ssr/EnvelopeOpen';
import { EyeIcon } from '@phosphor-icons/react/dist/ssr/Eye';
import { FacebookLogoIcon } from '@phosphor-icons/react/dist/ssr/FacebookLogo';
import { FileIcon } from '@phosphor-icons/react/dist/ssr/File';
import { FileArrowDownIcon } from '@phosphor-icons/react/dist/ssr/FileArrowDown';
import { FileArrowUpIcon } from '@phosphor-icons/react/dist/ssr/FileArrowUp';
import { FilePlusIcon } from '@phosphor-icons/react/dist/ssr/FilePlus';
import { FileTextIcon } from '@phosphor-icons/react/dist/ssr/FileText';
import { FirstAidKitIcon } from '@phosphor-icons/react/dist/ssr/FirstAidKit';
import { FlagIcon } from '@phosphor-icons/react/dist/ssr/Flag';
import { FloppyDiskIcon } from '@phosphor-icons/react/dist/ssr/FloppyDisk';
import { FlowerLotusIcon } from '@phosphor-icons/react/dist/ssr/FlowerLotus';
import { FolderIcon } from '@phosphor-icons/react/dist/ssr/Folder';
import { FolderOpenIcon } from '@phosphor-icons/react/dist/ssr/FolderOpen';
import { FunnelIcon } from '@phosphor-icons/react/dist/ssr/Funnel';
import { GearIcon } from '@phosphor-icons/react/dist/ssr/Gear';
import { GoogleLogoIcon } from '@phosphor-icons/react/dist/ssr/GoogleLogo';
import { HandIcon } from '@phosphor-icons/react/dist/ssr/Hand';
import { HandHeartIcon } from '@phosphor-icons/react/dist/ssr/HandHeart';
import { HandshakeIcon } from '@phosphor-icons/react/dist/ssr/Handshake';
import { HeadphonesIcon } from '@phosphor-icons/react/dist/ssr/Headphones';
import { HeadsetIcon } from '@phosphor-icons/react/dist/ssr/Headset';
import { HeartIcon } from '@phosphor-icons/react/dist/ssr/Heart';
import { HeartbeatIcon } from '@phosphor-icons/react/dist/ssr/Heartbeat';
import { HospitalIcon } from '@phosphor-icons/react/dist/ssr/Hospital';
import { HouseIcon } from '@phosphor-icons/react/dist/ssr/House';
import { HouseLineIcon } from '@phosphor-icons/react/dist/ssr/HouseLine';
import { ImageIcon } from '@phosphor-icons/react/dist/ssr/Image';
import { ImagesIcon } from '@phosphor-icons/react/dist/ssr/Images';
import { InfoIcon } from '@phosphor-icons/react/dist/ssr/Info';
import { KeyIcon } from '@phosphor-icons/react/dist/ssr/Key';
import { LinkIcon } from '@phosphor-icons/react/dist/ssr/Link';
import { LinkBreakIcon } from '@phosphor-icons/react/dist/ssr/LinkBreak';
import { LinkedinLogoIcon } from '@phosphor-icons/react/dist/ssr/LinkedinLogo';
import { ListIcon } from '@phosphor-icons/react/dist/ssr/List';
import { ListBulletsIcon } from '@phosphor-icons/react/dist/ssr/ListBullets';
import { ListChecksIcon } from '@phosphor-icons/react/dist/ssr/ListChecks';
import { ListNumbersIcon } from '@phosphor-icons/react/dist/ssr/ListNumbers';
import { MagicWandIcon } from '@phosphor-icons/react/dist/ssr/MagicWand';
import { MagnifyingGlassIcon } from '@phosphor-icons/react/dist/ssr/MagnifyingGlass';
import { MailboxIcon } from '@phosphor-icons/react/dist/ssr/Mailbox';
import { MapPinIcon } from '@phosphor-icons/react/dist/ssr/MapPin';
import { MapPinAreaIcon } from '@phosphor-icons/react/dist/ssr/MapPinArea';
import { MapTrifoldIcon } from '@phosphor-icons/react/dist/ssr/MapTrifold';
import { MicrophoneIcon } from '@phosphor-icons/react/dist/ssr/Microphone';
import { MinusIcon } from '@phosphor-icons/react/dist/ssr/Minus';
import { MinusCircleIcon } from '@phosphor-icons/react/dist/ssr/MinusCircle';
import { MoneyIcon } from '@phosphor-icons/react/dist/ssr/Money';
import { NavigationArrowIcon } from '@phosphor-icons/react/dist/ssr/NavigationArrow';
import { NoteIcon } from '@phosphor-icons/react/dist/ssr/Note';
import { NotePencilIcon } from '@phosphor-icons/react/dist/ssr/NotePencil';
import { NotepadIcon } from '@phosphor-icons/react/dist/ssr/Notepad';
import { PackageIcon } from '@phosphor-icons/react/dist/ssr/Package';
import { PaperPlaneRightIcon } from '@phosphor-icons/react/dist/ssr/PaperPlaneRight';
import { PaperclipIcon } from '@phosphor-icons/react/dist/ssr/Paperclip';
import { PathIcon } from '@phosphor-icons/react/dist/ssr/Path';
import { PauseIcon } from '@phosphor-icons/react/dist/ssr/Pause';
import { PauseCircleIcon } from '@phosphor-icons/react/dist/ssr/PauseCircle';
import { PencilIcon } from '@phosphor-icons/react/dist/ssr/Pencil';
import { PencilSimpleIcon } from '@phosphor-icons/react/dist/ssr/PencilSimple';
import { PersonSimpleWalkIcon } from '@phosphor-icons/react/dist/ssr/PersonSimpleWalk';
import { PhoneIcon } from '@phosphor-icons/react/dist/ssr/Phone';
import { PhonePlusIcon } from '@phosphor-icons/react/dist/ssr/PhonePlus';
import { PlayIcon } from '@phosphor-icons/react/dist/ssr/Play';
import { PlayCircleIcon } from '@phosphor-icons/react/dist/ssr/PlayCircle';
import { PlusIcon } from '@phosphor-icons/react/dist/ssr/Plus';
import { PlusCircleIcon } from '@phosphor-icons/react/dist/ssr/PlusCircle';
import { PlusSquareIcon } from '@phosphor-icons/react/dist/ssr/PlusSquare';
import { PrinterIcon } from '@phosphor-icons/react/dist/ssr/Printer';
import { PushPinIcon } from '@phosphor-icons/react/dist/ssr/PushPin';
import { QuestionIcon } from '@phosphor-icons/react/dist/ssr/Question';
import { QuotesIcon } from '@phosphor-icons/react/dist/ssr/Quotes';
import { RadioButtonIcon } from '@phosphor-icons/react/dist/ssr/RadioButton';
import { ReceiptIcon } from '@phosphor-icons/react/dist/ssr/Receipt';
import { ScalesIcon } from '@phosphor-icons/react/dist/ssr/Scales';
import { ScrollIcon } from '@phosphor-icons/react/dist/ssr/Scroll';
import { SealCheckIcon } from '@phosphor-icons/react/dist/ssr/SealCheck';
import { ShieldIcon } from '@phosphor-icons/react/dist/ssr/Shield';
import { ShieldCheckIcon } from '@phosphor-icons/react/dist/ssr/ShieldCheck';
import { ShieldChevronIcon } from '@phosphor-icons/react/dist/ssr/ShieldChevron';
import { ShieldPlusIcon } from '@phosphor-icons/react/dist/ssr/ShieldPlus';
import { SignOutIcon } from '@phosphor-icons/react/dist/ssr/SignOut';
import { SlidersHorizontalIcon } from '@phosphor-icons/react/dist/ssr/SlidersHorizontal';
import { SmileyIcon } from '@phosphor-icons/react/dist/ssr/Smiley';
import { SparkleIcon } from '@phosphor-icons/react/dist/ssr/Sparkle';
import { SquareIcon } from '@phosphor-icons/react/dist/ssr/Square';
import { StarIcon } from '@phosphor-icons/react/dist/ssr/Star';
import { StethoscopeIcon } from '@phosphor-icons/react/dist/ssr/Stethoscope';
import { StopIcon } from '@phosphor-icons/react/dist/ssr/Stop';
import { StopCircleIcon } from '@phosphor-icons/react/dist/ssr/StopCircle';
import { TelevisionIcon } from '@phosphor-icons/react/dist/ssr/Television';
import { ToiletIcon } from '@phosphor-icons/react/dist/ssr/Toilet';
import { TrashIcon } from '@phosphor-icons/react/dist/ssr/Trash';
import { TrayIcon } from '@phosphor-icons/react/dist/ssr/Tray';
import { TreeStructureIcon } from '@phosphor-icons/react/dist/ssr/TreeStructure';
import { TruckIcon } from '@phosphor-icons/react/dist/ssr/Truck';
import { UploadIcon } from '@phosphor-icons/react/dist/ssr/Upload';
import { UserIcon } from '@phosphor-icons/react/dist/ssr/User';
import { UserCircleIcon } from '@phosphor-icons/react/dist/ssr/UserCircle';
import { UserPlusIcon } from '@phosphor-icons/react/dist/ssr/UserPlus';
import { UsersIcon } from '@phosphor-icons/react/dist/ssr/Users';
import { UsersThreeIcon } from '@phosphor-icons/react/dist/ssr/UsersThree';
import { VideoCameraIcon } from '@phosphor-icons/react/dist/ssr/VideoCamera';
import { WarningIcon } from '@phosphor-icons/react/dist/ssr/Warning';
import { WarningCircleIcon } from '@phosphor-icons/react/dist/ssr/WarningCircle';
import { WheelchairIcon } from '@phosphor-icons/react/dist/ssr/Wheelchair';
import { WindowsLogoIcon } from '@phosphor-icons/react/dist/ssr/WindowsLogo';
import { XIcon } from '@phosphor-icons/react/dist/ssr/X';
import { XCircleIcon } from '@phosphor-icons/react/dist/ssr/XCircle';
import { XLogoIcon } from '@phosphor-icons/react/dist/ssr/XLogo';

/** IconComponent is a Phosphor icon: one component, rendered at any weight. */
export type IconComponent = Icon;

/**
 * iconGlyphs maps every icon name the design system can render onto a Phosphor
 * glyph.
 *
 * Phosphor draws one glyph per concept and varies the stroke through a `weight`
 * prop, which is how FontAwesome's families worked too. That means a single map
 * covers every weight: `fal` and `fas` are the same glyph drawn `light` and
 * `fill`, rather than two unrelated icons as they had to be under Material.
 *
 * Keys keep their FontAwesome spelling so the ~100 existing call sites, and the
 * icon names held in the database and in Sanity, continue to resolve unchanged.
 */
export const iconGlyphs = {
  'exclamation-triangle': WarningIcon,
  'exclamation-circle': WarningCircleIcon,
  'info-circle': InfoIcon,
  'circle-question': QuestionIcon,
  'question-circle': QuestionIcon,
  check: CheckIcon,
  'check-circle': CheckCircleIcon,
  'check-square': CheckSquareIcon,
  square: SquareIcon,
  circle: CircleIcon,
  'dot-circle': RadioButtonIcon,
  times: XIcon,
  xmark: XIcon,
  'circle-xmark': XCircleIcon,
  'badge-check': SealCheckIcon,
  'arrow-circle-down': ArrowCircleDownIcon,
  'arrow-circle-up': ArrowCircleUpIcon,
  'arrow-down-to-bracket': DownloadIcon,
  'arrow-right-from-bracket': SignOutIcon,
  'arrows-rotate': ArrowsClockwiseIcon,
  'rotate-right': ArrowClockwiseIcon,
  'long-arrow-left': ArrowLeftIcon,
  'long-arrow-right': ArrowRightIcon,
  'chevron-down': CaretDownIcon,
  'chevron-left': CaretLeftIcon,
  'chevron-right': CaretRightIcon,
  'chevron-up': CaretUpIcon,
  'chevrons-down': CaretDoubleDownIcon,
  'chevrons-left': CaretDoubleLeftIcon,
  'chevrons-right': CaretDoubleRightIcon,
  'chevrons-up': CaretDoubleUpIcon,
  'location-arrow': NavigationArrowIcon,
  route: PathIcon,
  map: MapTrifoldIcon,
  plus: PlusIcon,
  'circle-plus': PlusCircleIcon,
  'circle-minus': MinusCircleIcon,
  'plus-square': PlusSquareIcon,
  minus: MinusIcon,
  'horizontal-rule': MinusIcon,
  download: DownloadIcon,
  upload: UploadIcon,
  'cloud-arrow-up': CloudArrowUpIcon,
  'cloud-arrow-down': CloudArrowDownIcon,
  'file-arrow-down': FileArrowDownIcon,
  'file-arrow-up': FileArrowUpIcon,
  'floppy-disk': FloppyDiskIcon,
  copy: CopyIcon,
  trash: TrashIcon,
  edit: PencilSimpleIcon,
  pen: PencilIcon,
  pencil: PencilIcon,
  'pen-field': NotePencilIcon,
  print: PrinterIcon,
  search: MagnifyingGlassIcon,
  'magnifying-glass': MagnifyingGlassIcon,
  'magnifying-glass-location': MapPinAreaIcon,
  paperclip: PaperclipIcon,
  link: LinkIcon,
  'link-slash': LinkBreakIcon,
  'arrow-up-right-from-square': ArrowSquareOutIcon,
  play: PlayIcon,
  pause: PauseIcon,
  stop: StopIcon,
  'circle-play': PlayCircleIcon,
  'circle-pause': PauseCircleIcon,
  'circle-stop': StopCircleIcon,
  'paper-plane-top': PaperPlaneRightIcon,
  ellipsis: DotsThreeIcon,
  'ellipsis-vertical': DotsThreeVerticalIcon,
  'sliders-h': SlidersHorizontalIcon,
  filter: FunnelIcon,
  gear: GearIcon,
  list: ListBulletsIcon,
  bars: ListIcon,
  'list-ol': ListNumbersIcon,
  'list-check': ListChecksIcon,
  clipboard: ClipboardIcon,
  'clipboard-list': ClipboardTextIcon,
  'clipboard-check': ListChecksIcon,
  memo: NotepadIcon,
  'note-sticky': NoteIcon,
  file: FileIcon,
  'file-lines': FileTextIcon,
  'file-plus': FilePlusIcon,
  'file-contract': ScrollIcon,
  folder: FolderIcon,
  'folder-open': FolderOpenIcon,
  book: BookIcon,
  'book-open': BookOpenIcon,
  'book-heart': BookOpenIcon,
  bookmark: BookmarkIcon,
  'quote-left': QuotesIcon,
  'quote-right': QuotesIcon,
  image: ImageIcon,
  images: ImagesIcon,
  'disc-drive': DiscIcon,
  video: VideoCameraIcon,
  microphone: MicrophoneIcon,
  tv: TelevisionIcon,
  envelope: EnvelopeIcon,
  envelopes: EnvelopeIcon,
  'envelope-open-text': EnvelopeOpenIcon,
  mailbox: MailboxIcon,
  inbox: TrayIcon,
  message: ChatIcon,
  comments: ChatsIcon,
  'comment-dots': ChatDotsIcon,
  phone: PhoneIcon,
  'phone-plus': PhonePlusIcon,
  bell: BellIcon,
  headphones: HeadphonesIcon,
  headset: HeadsetIcon,
  'user-headset': HeadsetIcon,
  user: UserIcon,
  'circle-user': UserCircleIcon,
  'user-plus': UserPlusIcon,
  users: UsersIcon,
  'user-group': UsersThreeIcon,
  'user-nurse': StethoscopeIcon,
  'person-walking': PersonSimpleWalkIcon,
  smile: SmileyIcon,
  'hand-holding': HandIcon,
  'hand-holding-heart': HandHeartIcon,
  'hands-holding-heart': HandHeartIcon,
  'hands-helping': HandshakeIcon,
  wheelchair: WheelchairIcon,
  home: HouseIcon,
  house: HouseIcon,
  'house-blank': HouseIcon,
  'house-heart': HouseLineIcon,
  building: BuildingsIcon,
  city: CityIcon,
  hospital: HospitalIcon,
  bed: BedIcon,
  hotel: BedIcon,
  couch: CouchIcon,
  toilet: ToiletIcon,
  box: PackageIcon,
  bus: BusIcon,
  'truck-fast': TruckIcon,
  'map-marker': MapPinIcon,
  'map-marker-alt': MapPinIcon,
  'location-dot': MapPinIcon,
  heart: HeartIcon,
  'circle-heart': HeartIcon,
  'heart-pulse': HeartbeatIcon,
  'kit-medical': FirstAidKitIcon,
  spa: FlowerLotusIcon,
  'shield-alt': ShieldIcon,
  'shield-halved': ShieldChevronIcon,
  'shield-check': ShieldCheckIcon,
  'shield-plus': ShieldPlusIcon,
  'key-skeleton': KeyIcon,
  'pound-sign': CurrencyGbpIcon,
  'sterling-sign': CurrencyGbpIcon,
  'circle-sterling': CurrencyGbpIcon,
  'money-bills': MoneyIcon,
  coins: CoinsIcon,
  'money-check-pen': ReceiptIcon,
  'scale-balanced': ScalesIcon,
  calendar: CalendarBlankIcon,
  'calendar-days': CalendarDotsIcon,
  'calendar-check': CalendarCheckIcon,
  camera: CameraIcon,
  clock: ClockIcon,
  eye: EyeIcon,
  'closed-captioning': ClosedCaptioningIcon,
  thumbtack: PushPinIcon,
  flag: FlagIcon,
  star: StarIcon,
  sparkles: SparkleIcon,
  'wand-magic-sparkles': MagicWandIcon,
  'party-horn': ConfettiIcon,
  sitemap: TreeStructureIcon,
  apple: AppleLogoIcon,
  facebook: FacebookLogoIcon,
  linkedin: LinkedinLogoIcon,
  'x-twitter': XLogoIcon,
  google: GoogleLogoIcon,
  microsoft: WindowsLogoIcon,
} as const satisfies Record<string, IconComponent>;

/**
 * brandIcons are the third-party logos on the social sign-in buttons. They are
 * always drawn filled: a brand mark at a line weight reads as a sketch of the
 * logo rather than the logo itself.
 */
export const brandIcons = new Set<string>([
  'apple',
  'facebook',
  'linkedin',
  'x-twitter',
  'google',
  'microsoft',
]);

/** Icons is every icon name the design system can render. */
export type Icons = keyof typeof iconGlyphs;

/**
 * strokeOnlyIcons are glyphs with no enclosed area: a tick, a cross, a chevron,
 * a row of dots. Phosphor's `fill` weight has nothing to fill on these, so it
 * draws them knocked out of a solid block (or, for the carets, as a solid
 * triangle), which is a different drawing rather than a heavier stroke. The
 * solid family draws them `bold` instead, which is what FontAwesome Solid did.
 *
 * Derived from Phosphor's path data: every registry glyph whose `fill` path is
 * a full-size rounded block, plus the carets. A glyph that genuinely fills to a
 * block, such as `check-square` or `closed-captioning`, is not listed.
 */
export const strokeOnlyIcons = new Set<Icons>([
  'check',
  'times',
  'xmark',
  'plus',
  'minus',
  'horizontal-rule',
  'link',
  'link-slash',
  'list',
  'list-ol',
  'bars',
  'list-check',
  'clipboard-check',
  'ellipsis',
  'ellipsis-vertical',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chevrons-down',
  'chevrons-left',
  'chevrons-right',
  'chevrons-up',
]);

/** iconNames lists every renderable icon name, for stories and validation. */
export const iconNames: Icons[] = Object.keys(iconGlyphs) as Icons[];
